import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Auth from '../services/Auth';
import styled from 'styled-components';
import { getTheme } from '../global/utils';
import MainLayout from '../layouts/MainLayout';
import PageHeading from '../components/shared/PageHeading';
import PageBody from '../components/shared/PageBody';
import Heading from '../components/text/Heading';
import AlarmsAppliedFilters from './alarms/AlarmsAppliedFilters';
import AlarmsFilters from './alarms/AlarmsFilters';
import Button from '../components/buttons/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import AlarmsTableList from './alarms/AlarmsTableList';
import AlarmsModal from './alarms/AlarmsModal';
import axios from "axios/index";
import alarmsFiltersData from "../data/alarmsFiltersData";
import alarmsChartVariablesData from "../data/alarmsChartVariablesData";
import lineChartDataScreens from "../data/lineChartDataScreens";

const auth = new Auth();

const AlarmsContent = styled.div`
  .alarms-controls  {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    &__trigger {
      margin-bottom: 0;
    }

    &__selected {
      margin: ${getTheme('spacer', 's')} ${getTheme('spacer', 's')} ${getTheme('spacer', 's')} 0;
      white-space: nowrap;
    }

    &__selected-change {
      margin-right: ${getTheme('spacer', 'l')};
    }
  }
`;

const empty_snapshots = [{},{},{},{},{}]

class Alarms extends Component {
  constructor() {
    super();

    this.state = {
      internal_last_snapshots: empty_snapshots,
      internal_variables_lists: null,
      showModal: false,
      loading: true,
      noData: false,  //This should be dynamic
      modalTitle: '',
      filtersVisibility: false,
      activeFilters: {
        period: 1,
        ut: 0,
        groupid: 0,
        triggerid: 0,
      },
      item: {
        id: 0,
        vars: []
      },
      editableChart: {},
      singleAlarmView: false,
      singleViewId: '',
      modalLoading: false, //This should be dynamic
    };
    this.updateFilters = this.updateFilters.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.openPanel = this.openPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.addChart = this.addChart.bind(this);
    this.removeChart = this.removeChart.bind(this);
    this.editChart = this.editChart.bind(this);
    this.updateVars = this.updateVars.bind(this);
    this.checkSingleView = this.checkSingleView.bind(this);
    this.updateChartName = this.updateChartName.bind(this);
  }

  getSnapshotVariablesListsUrl(p_filter) {
    let url = process.env.REACT_APP_API_SERVER +'/api/v01/snapshot/variables/lists';
    url += '/?date_time='+p_filter.date_time+'&crc='+p_filter.crc+'&ut='+p_filter.ut+'&groupid='+p_filter.groupid;
    return url;
  }

  getSnapshotVariablesLists(p_filter) {
    if (process.env.REACT_APP_STATIC === '1') {
        let res_data = {
            "code": 200,
            "snapshot_variables_lists": alarmsChartVariablesData
        };
        let internal_variables_lists = res_data.snapshot_variables_lists;
        this.setState({
            internal_variables_lists: internal_variables_lists,
            showModal: true
        });
        return true;
    }
    let url = this.getSnapshotVariablesListsUrl(p_filter);
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.withCredentials = true;
    axios.get(url)
        .then(res => {
            let snapshot_variables_lists = res.data.snapshot_variables_lists;
            let internal_variables_lists = JSON.parse(snapshot_variables_lists);
            this.setState({
                internal_variables_lists: internal_variables_lists,
                showModal: true
            });
        })
  }

  handleOpenModal(item, isCtrlPressed, itemKey, e) {
   if (isCtrlPressed) {
      return;
    }
    if (e){
      e.preventDefault();
    }
    this.setState({
      item: item,
      itemKey: itemKey,
    });
    this.getSnapshotVariablesLists({'date_time': item.date_time, 'crc': item.crc, 'ut': item.ut, 'groupid': item.groupid});
  }

  handleCloseModal() {
    this.setState({ showModal: false });
    this.closePanel();
  }

  updateFilters(selectedFilters) {
    this.setState({
      activeFilters: {
        ...this.state.activeFilters,
        ...selectedFilters,
      },
    });
    let ut_code, groupid_code, triggerid_code;
    if (selectedFilters.ut) {
        ut_code = alarmsFiltersData.ut[selectedFilters.ut].code;
    }
    if (selectedFilters.groupid) {
      groupid_code = alarmsFiltersData.groupid[selectedFilters.groupid].code;
    }
    if (selectedFilters.triggerid) {
        triggerid_code = alarmsFiltersData.triggerid[selectedFilters.triggerid].code;
    }
    this.get_last_snapshots({'ut': ut_code, 'groupid': groupid_code, 'triggerid': triggerid_code});
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  toggleFilters() {
    this.setState({
      filtersVisibility: !this.state.filtersVisibility,
    });
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  closePanel() {
    this.setState({
      isPanelOpen: false,
    });
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  openPanel() {
    this.setState({
      isPanelOpen: true,
    });
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  addChart() {
    let currentCharts;
    let currentItem;
    let currentSnapshots = this.state.internal_last_snapshots;
    if (!this.state.item.charts) {
      this.setState({item: {...this.state.item, charts: []}});
      currentCharts = [];
    } else {
      currentCharts = this.state.item.charts
    }
    const chartLength = currentCharts.length;
    const newChart = { name: 'Chart ' + (chartLength + 1), id: chartLength, vars: [] };
    currentCharts.push(newChart);
    currentItem = this.state.item;
    currentItem.charts = currentCharts;
    currentSnapshots[this.state.itemKey] = currentItem;
    this.setState({
      item: currentItem,
      internal_last_snapshots: currentSnapshots,
      editableChart: newChart,
    });

    this.openPanel();
  }

  removeChart(targetId) {
    let currentCharts = this.state.item.charts;
    let currentItem = this.state.item;
    let currentSnapshots = this.state.internal_last_snapshots;
    delete currentCharts[targetId];
    currentItem.charts = currentCharts;
    this.setState({ item: currentItem });
    currentSnapshots[this.state.itemKey] = currentItem;
    this.setState({
      internal_last_snapshots: currentSnapshots,
    });
    this.closePanel();
  }

  editChart(targetId) {
    let openChart = this.state.item.charts[targetId];
    this.setState({
      editableChart: openChart,
    });
    this.openPanel();
  }

  selectedVarsToStr (selectedVars) {
    let variables = '';
    for (let v in selectedVars) {
      if (v > 0) {
        variables += ',';
      }
      variables += selectedVars[v]["varId"];
    }
    return variables;
  }

  getSnapshotVariablesValuesUrl(p_variables) {
    let url = process.env.REACT_APP_API_SERVER +'/api/v01/snapshot/variables';
    url += '/?date_time='+this.state.item.date_time+
        '&crc='+this.state.item.crc+
        '&ut='+this.state.item.ut+
        '&groupid='+this.state.item.groupid+
        '&variables='+p_variables;
    return url;
  }
  getSnapshotVariablesValues(targetId, selectedVars, callBack) {
    let variables = this.selectedVarsToStr(selectedVars);
    let url = this.getSnapshotVariablesValuesUrl(variables);
    let chart_loading = false;
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.withCredentials = true;
    axios.get(url)
        .then(res => {
            let snapshotVariablesValues = JSON.parse(res.data.snapshot_variables_values);
            this.updateValues(targetId, selectedVars, snapshotVariablesValues, chart_loading, callBack);
        })
  }

  updateValues(targetId, selectedVars, snapshotVariablesValues, chart_loading, callBack) {
    let currentCharts = this.state.item.charts;
    currentCharts[targetId].vars = selectedVars;
    currentCharts[targetId].values = snapshotVariablesValues;
    currentCharts[targetId].chart_loading = chart_loading;
    this.setState({
      charts: currentCharts,
    }, ()=>{
        if (callBack) {
          callBack();
        }
    });
  }

  updateChartName(targetId, newName) {
    let currentCharts = this.state.item.charts;
    currentCharts[targetId].name = newName;
    this.setState({
      charts: currentCharts
    })
  }

  removeValuesByVarId(targetId, varIdToRemove) {
      let currentCharts = this.state.item.charts;
      let currentSnapshotVariablesValues = currentCharts[targetId].values;
      let series = currentSnapshotVariablesValues.series;
      for (var i in series) {
        if (series[i].name === varIdToRemove) {
          currentSnapshotVariablesValues.series.splice(i,1);
          break;
        }
      }
      return currentSnapshotVariablesValues;
  }

  updateVars(targetId, selectedVars, action, varIdToRemove, callBack) {
    let chart_loading = false;
    if (selectedVars.length === 0) {
      this.updateValues(targetId, selectedVars, [], chart_loading, callBack);
      return true;
    };
    if (action === 'remove') {
      let snapshotVariablesValues = this.removeValuesByVarId(targetId, varIdToRemove);
      chart_loading = false;
      this.updateValues(targetId, selectedVars, snapshotVariablesValues, chart_loading, callBack);
      return true;
    }
    chart_loading = true;
    this.updateValues(targetId, selectedVars, [], chart_loading, callBack);
    if (process.env.REACT_APP_STATIC === '1') {
        let res_data = {
            "code": 200,
            "snapshot_variables_values": lineChartDataScreens
        };
        let snapshotVariablesValues = res_data.snapshot_variables_values;
        chart_loading = false;
        this.updateValues(targetId, selectedVars, snapshotVariablesValues, chart_loading, callBack);
    } else {
        this.getSnapshotVariablesValues(targetId, selectedVars, callBack);
    }
  }

  checkSingleView() {
    if (this.state.singleAlarmView){
      this.handleOpenModal(this.state.internal_last_snapshots[this.state.singleViewId], false, this.state.singleViewId);
    }
  }

  get_last_snapshots_url(p_filter) {
    let url = process.env.REACT_APP_API_SERVER +'/api/v01/snapshots/';
    let params = ''
    if (p_filter.ut) {
      params += 'ut='+p_filter.ut
    }
    if (p_filter.groupid) {
      if (params) {
        params += '&';
      }
      params += 'groupid='+p_filter.groupid
    }
    if (p_filter.triggerid) {
      if (params) {
        params += '&';
      }
      params += 'triggerid='+p_filter.triggerid
    }
    if (params) {
      url += 'search/?' + params;
    }
    return url;
  }

  get_last_snapshots(p_filter) {
    this.setState({loading: true});
    if (process.env.REACT_APP_STATIC === '1') {
      let res_data = {"code":200,"last_snapshots":[{"date_time":"1563079159.0854836","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"6","sec":1,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079155.8709433","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"8","sec":4,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079155.870933","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"6","sec":4,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079153.905781","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"8","sec":4,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079153.9057753","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"7","sec":4,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079150.9713755","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"7","sec":2,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079150.8111308","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"8","sec":3,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079150.8111198","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"6","sec":3,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079148.8258193","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"8","sec":3,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079148.8258138","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"7","sec":3,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079145.7513459","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"8","sec":2,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079145.7513344","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"6","sec":2,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079143.7454464","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"8","sec":2,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079143.7454407","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"7","sec":2,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079140.1908004","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"8","sec":1,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079140.190797","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"7","sec":1,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079140.1907892","crc":"92563411","component":"ACR","groupid":"ACR1","triggerid":"6","sec":1,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:39"},{"date_time":"1563079138.0258336","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"8","sec":1,"ut":"36","alarms":"DCCU_ALR::ERR_PRECHARGE_CONTACTOR_OPEN DCCU_ALR::DCDC_2_ERROR DCCU_ALR::DCDC_1_ERROR","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:38"},{"date_time":"1563079138.02583","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"7","sec":1,"ut":"36","alarms":"MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_StatusW MVB_TS::UCU_C2_FL_ErrorRegister MVB_TS::UCU_C2_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/14","time":"06:38"},{"date_time":"1562792777.0235844","crc":"92563411","component":"ACR","groupid":"ACR2","triggerid":"6","sec":1,"ut":"36","alarms":"MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_StatusW MVB_TS::UCU_C1_FL_ErrorRegister MVB_TS::UCU_C1_FL_ErrorRegister","year":"2019","month":"07","day":"10","date":"2019/07/10","time":"23:06"}]};
      let alarms = res_data.last_snapshots;
      this.setState(
          {
              internal_last_snapshots: alarms,
              loading: false
          },
          ()=>{this.checkSingleView()}
      );
      return true;
    }
    let url = this.get_last_snapshots_url(p_filter);
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.withCredentials = true;
    axios.get(url)
        .then(res => {
            let alarms = res.data.last_snapshots;
            this.setState(
                {
                    internal_last_snapshots: alarms,
                    loading: false
                },
                ()=>{this.checkSingleView()}
            );
        })
  }

  componentWillMount() {
    let alarmId = new URL(window.location.href).searchParams.get('id');
    if (alarmId) {
      alarmId = alarmId - 1;
      this.setState({
        singleAlarmView: true,
        singleViewId: alarmId
      });
      this.handleOpenModal({}, false, alarmId);
    }
  }

  componentDidMount() {
    this.get_last_snapshots({'ut': '', 'groupid': '', 'triggerid': ''});
  }

  render() {
    if (!auth.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (!auth.isCbm() ) {
      return <Redirect to="/" />;
    }

    let itemCharts = [];

    if (this.state.item.charts) {
      itemCharts = this.state.item.charts;
    }

    return (
      <AlarmsContent>
        <MainLayout>
          <PageHeading>
            <Heading level="heading1" nomargin>
              <div className="alarms-controls">
              <h1>Snapshots</h1>
              <Button
                className="alarms-controls__trigger"
                secondary
                size="medium"
                onClick={this.toggleFilters}
                iconBefore={<FontAwesomeIcon icon={faFilter} />}
              >
                Filter
              </Button>
              </div>
            </Heading>
          </PageHeading>
          <PageBody>
            <AlarmsAppliedFilters
              updateFilters={this.updateFilters}
              activeFilters={this.state.activeFilters}
            />

            <AlarmsTableList
                handleClick={this.handleOpenModal}
                data={this.state.internal_last_snapshots}
                loading={this.state.loading}
                noData={this.state.noData}
              noDataAction={this.toggleFilters}
            />

            <AlarmsFilters
              filtersCloseAction={this.toggleFilters}
              filtersVisibility={this.state.filtersVisibility}
              updateFilters={this.updateFilters}
              activeFilters={this.state.activeFilters}
            />

          </PageBody>

          <AlarmsModal
            loading={this.state.modalLoading}
            item={this.state.item}
            isOpen={this.state.showModal}
            closeModal={this.handleCloseModal}
            isPanelOpen={this.state.isPanelOpen}
            closePanel={this.closePanel}
            updateVars={this.updateVars}
            updateChartName={this.updateChartName}
            addChart={this.addChart}
            removeChart={this.removeChart}
            editChart={this.editChart}
            editableChart={this.state.editableChart}
            charts={itemCharts}
            wontClose={this.state.singleAlarmView}
            data_variables_lists={this.state.internal_variables_lists}
          />
        </MainLayout>
      </AlarmsContent>
    );
  }
}
export default Alarms;



// WEBPACK FOOTER //
// ./src/pages/Alarms.js